import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import Approval from "../../../components/SidebarMenuComponents/ApprovalComponent/Approval";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function ApprovalPage() {
   
    return (
        <Page title="Request Approval | tiketic" >
           
            <StickyHeader title="Request Approval" />

            <ContentStyle>
                <Approval/>
            </ContentStyle>
        </Page>
    );
}

